import { render, staticRenderFns } from "./ClientDeposit.vue?vue&type=template&id=54bbd8f3&"
import script from "./ClientDeposit.vue?vue&type=script&lang=js&"
export * from "./ClientDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports